// useCalendarDateFields.js

import { useMemo } from 'react';

import { getCalendarDateFields } from 'views/calendar/shared/calendarTemporalFields';
import { getCalendarTypeKey } from 'views/calendar/shared/calendarUtils';

const useCalendarDateFields = (typeDef, options = {}) => {
  const preferredFieldKey = String(options?.preferredFieldKey || options?.calendarField || '').trim();
  const typeKey = useMemo(() => getCalendarTypeKey(typeDef), [typeDef]);

  const dateFields = useMemo(() => {
    if (!typeKey) return [];
    return getCalendarDateFields(typeDef, { preferredFieldKey });
  }, [preferredFieldKey, typeDef, typeKey]);

  return {
    typeKey,
    dateFields,
  };
};

export default useCalendarDateFields;
